module.exports = __webpack_public_path__ + "img/member-blue.e5e17833.svg";